import { render, staticRenderFns } from "./LayoutBody.vue?vue&type=template&id=748fb7e8&scoped=true&"
import script from "./LayoutBody.vue?vue&type=script&lang=js&"
export * from "./LayoutBody.vue?vue&type=script&lang=js&"
import style0 from "./LayoutBody.vue?vue&type=style&index=0&id=748fb7e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748fb7e8",
  null
  
)

export default component.exports